import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function bulkquickfilterreducer(state = initialstate.bulkquickfilter, action) {
	switch (action.type) {
		case actions.BULK_QUICK_FILTER: {
			return action.value;
		}

		default:
			return state;
	}
}

